export const Encrypt = () => (
  <svg width='7' height='10' viewBox='0 0 7 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M6 3.5V3C6 1.62 4.88 0.5 3.5 0.5C2.12 0.5 1 1.62 1 3V3.5C0.45 3.5 0 3.95 0 4.5V8.5C0 9.05 0.45 9.5 1 9.5H6C6.55 9.5 7 9.05 7 8.5V4.5C7 3.95 6.55 3.5 6 3.5ZM5.2 3.5H1.8V3C1.8 2.06 2.56 1.3 3.5 1.3C4.44 1.3 5.2 2.06 5.2 3V3.5Z'
      fill='#64748B'
    />
  </svg>
);
